export const en = {
    "admin": "Admin",
    "dialogs": "Dialogs",
    "projects": "Projects",
    "teach-alice-new": "Teach Alice new things",
    "teach-yasmina-new": "Teach Yasmina new things",
    "talk-and-play": "Communicate with customers, take orders or play something",
    "title": "Dialogs platform",
    "title-yango": "Yango Dialogs",
    "yandex": "Yandex",
    "yango": "Yango",
    
} as const;
export const ru = {
    "admin": "Админ",
    "dialogs": "Диалоги",
    "projects": "Проекты",
    "teach-alice-new": "Научите Алису новому",
    "teach-yasmina-new": "Научите Ясмину новому",
    "talk-and-play": "Общаться с клиентами, принимать заказы или играть во что-нибудь",
    "title": "Платформа диалогов",
    "title-yango": "Yango Dialogs",
    "yandex": "Яндекс",
    "yango": "Yango",
} as const;
